module.exports = __webpack_public_path__ + "img/ECU-logo.c2f4388e.jpg";